import { useEffect, useState, useRef } from 'react';
import apiService from '../../axios/apiService';

export const useDashboard = (filterParams) => {
  const [data, setData] = useState();
  const prevParamsRef = useRef();

  const getList = async (params) => {
    // Fetch dashboard data
    const list = await apiService.getDashboard(params || filterParams);
    list && setData(list); // update data state
    return list;
  };

  // Initial Render and when filterParams change
  useEffect(() => {
    const currentParams = filterParams ? `${filterParams.startDate}_${filterParams.endDate}` : 'default';
    const prevParams = prevParamsRef.current;

    if (currentParams !== prevParams) {
      prevParamsRef.current = currentParams;
      getList();
    }
  }, [filterParams?.startDate, filterParams?.endDate]);

  return {
    data,
    getList,
  };
};